import styled from "styled-components";

export const TimelineWrapper = styled.div.attrs({
  className: 'timeline-wrapper'
})`
  overflow-y: auto;
  height: 100vh;
  padding: 1rem;
  font-family: ${(props) => props.theme.fonts.family.inter};
  font-size: 12px;
  scrollbar-width: thin;
`;

export const DateWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 1rem 0;
  font-size: 12px;
  color: ${(props) => props.theme.colors.taupeGray};
  font-family: ${(props) => props.theme.fonts.family.inter};
  position: relative;

  span {
    background-color: ${(props) => props.theme.colors.white};
    padding: 0 0.5rem;
    z-index: 1;
  }

  &::before,
  &::after {
    content: "";
    height: 1px;
    background-color: ${(props) => props.theme.colors.lightGrey};
    position: absolute;
    top: 50%;
    width: 45%;
  }

  &::before {
    left: 0;
    margin-right: 10px;
  }

  &::after {
    right: 0;
    margin-left: 10px;
  }
`;

export const MessageWrapper = styled.div`
  display: flex;
  justify-content: ${(props) => props.isAgent ? "flex-start" : "flex-end"};
  align-items: flex-start;
  margin: 1.5rem 0;
  position: relative;
  font-size: 12px;
  font-family: ${(props) => props.theme.fonts.family.inter};

  .assistant-avatar {
    width: 32px;
    height: 32px;
    margin-top: ${(props) => (props.isEmail ? "30px" : "10px")};
    border-radius: 50%;
    background-color: ${(props) => props.theme.colors.taupeGray};
    color: ${(props) => props.theme.colors.white};
    font-size: 14px;
    font-weight: bold;
    display: ${(props) => (props.isAgent ? "flex" : "none")};
    align-items: center;
    justify-content: center;
    margin-right: 12px;
    flex-shrink: 0;
  }

  .avatar {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background-color: ${(props) => props.theme.colors.taupeGray};
    color: ${(props) => props.theme.colors.white};
    font-size: 12px;
    font-weight: bold;
    display: ${(props) => (props.isAgent ? "none" : "flex")};
    align-items: center;
    justify-content: center;
    margin-left: 8px;
    margin-right: 12px;

    flex-shrink: 0;
    order: ${(props) => (props.isAnswerAgent ? 0 : 1)};
    position: relative;
  }

  .markdown-content {
    width: 100%;
    overflow-x: auto;
    position: relative;
    isolation: isolate;
    contain: content;
    
    ${props => props.theme.markdownStyles}

    p {
      margin: 0.5em 0;
    }

    .highlighted-text {
      background-color: #FFEB3B !important;
      display: inline !important;
      padding: 0 2px !important;
      border-radius: 2px !important;
      font-weight: bold !important;
      color: inherit !important;
      position: relative !important;
      z-index: 1 !important;
    }

    .html-content {
      width: 100%;
      position: relative;
      isolation: isolate;
      contain: content;
      
      * {
        max-width: 100%;
      }
      
      table {
        border-collapse: collapse;
        width: 100%;
        margin: 8px 0;
      }

      th, td {
        border: 1px solid ${props => props.theme.colors.lightGrey};
        padding: 8px;
        text-align: left;
      }

      th {
        background-color: ${props => props.theme.colors.culturedGray};
      }

      tr:nth-child(even) {
        background-color: ${props => props.theme.colors.culturedGray};
      }
    }

    max-width: 600px;
    table {
      width: 100%;
      margin-top: 16px;
    }

    @media (max-width: 1365px) {
      max-width: 200px;
    }
  }

  .message-content {
    padding: 12px;
    border-radius: 8px;
    background-color: ${props => 
      props.isAgent 
        ? props.theme.colors.white 
        : props.theme.colors.culturedGray
    };
    max-width: 600px;
    position: relative;
    isolation: isolate;
    contain: content;
    overflow: hidden;
  }

  .email-body {
    padding: 16px;
    width: 100%;
    position: relative;
    isolation: isolate;
    contain: content;
    
    &.collapsed {
      display: none;
    }

    strong {
      display: block;
      margin-bottom: 12px;
    }

    .html-content {
      width: 100%;
      position: relative;
      isolation: isolate;
      contain: content;
      
      * {
        max-width: 100%;
      }
      
      table {
        width: 100%;
        margin-top: 16px;
        th {
          background-color: ${props => props.theme.colors.culturedGray};
          font-weight: 600;
        }
        
        td, th {
          border: 1px solid ${props => props.theme.colors.lightGrey};
          padding: 8px 12px;
        }
      }
    }
  }
`;

export const CollapsableWrapper = styled.div`
  margin: 1rem 0;

  background-color: ${(props) => props.theme.colors.white};
  overflow: hidden;
  font-family: ${(props) => props.theme.fonts.family.inter};
  max-width: 90%;

  .email-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.75rem 1rem;
    cursor: pointer;
    width: 100%;
    border-bottom: 1px solid ${(props) => props.theme.colors.lightGrey};

    &:not(.expanded) {
      border-bottom: none;
    }

    .icon {
      margin-right: 8px;
      flex-shrink: 0;
    }

    .email-avatar {
      width: 32px;
      height: 32px;
      border-radius: 50%;
      color: ${(props) => props.theme.colors.white};
      font-size: 14px;
      font-weight: bold;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 12px;
      flex-shrink: 0;
    }

    &:hover::after {
      content: attr(data-tooltip);
      position: absolute;
      top: -10%;
      left: 10%;
      background-color: ${(props) => props.theme.colors.black};
      color: ${(props) => props.theme.colors.white};
      font-size: 10px;
      padding: 4px 8px;
      border-radius: 4px;
      white-space: nowrap;
      z-index: 10;
    }

    .email-icon {
      margin-right: 0.5rem;
      font-size: 1.2rem;
    }

    .sender-info {
      display: flex;
      align-items: center;
      font-weight: bold;
      color: ${(props) => props.theme.colors.darkCharcoal};
    }

    .email-date {
      font-size: 12px;
      color: ${(props) => props.theme.colors.taupeGray};
      margin-left: 20%;
    }

    button {
      background: none;
      border: none;
      font-size: 12px;
      cursor: pointer;
      color: ${(props) => props.theme.colors.darkCharcoal};
    }
  }

  .email-body {
    padding: 1rem;
    font-size: 12px;
    color: ${(props) => props.theme.colors.darkCharcoal};
    border-top: 1px solid ${(props) => props.theme.colors.lightGrey};
    line-height: 1.4;
    width: 100%;
    transition: max-height 0.3s ease-out, padding 0.3s ease-out;
    max-height: 2000px;
    opacity: 1;
    transition: all 0.3s ease-out;

    &.collapsed {
      max-height: 0;
      padding: 0;
      opacity: 0;
      overflow: hidden;
      border-top: none;
      margin: 0;
    }

    strong {
      display: block;
      margin-bottom: 12px;
    }

    .markdown-content {
      max-width: 100%;
      table {
        width: 100%;
        margin-top: 16px;
      }
      @media (max-width: 1365px) {
        max-width: 550px;
      }
    }
  }
`;

export const ErrorMessage = styled.div`
  & p {
    font-size: 14px;
    font-weight: 600;
    text-align: center;
  }
`;

export const DateSenderWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`;
